<template>
  <b-form @submit.prevent="save">
    <b-row>
      <b-col  md="6" lg="4">
        <b-form-group :label="`${$t('FIRST_NAME')} *`">
          <b-form-input
            type="text"
            v-model.trim="applicantData.first_name"
            name="first_name">
          </b-form-input>
          <validation-description :show="$v.applicantData.first_name.$dirty && $v.applicantData.first_name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="6" lg="4">
        <b-form-group :label="`${$t('LAST_NAME')} *`">
          <b-form-input
              type="text"
              v-model.trim="applicantData.last_name"
              name="last_name">
          </b-form-input>
          <validation-description :show="$v.applicantData.last_name.$dirty && $v.applicantData.last_name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="6" lg="4">
        <b-form-group :label="$t('DATE_OF_BIRTH')">
          <date-picker :value="applicantData.date_of_birth" @change="updateDateOfBirth" :placeholder="$t('SELECT_DATE')"></date-picker>
        </b-form-group>
      </b-col>
      <b-col  md="6" lg="4">
        <b-form-group :label="$t('PLACE_OF_BIRTH')">
          <b-form-input
              type="text"
              v-model="applicantData.place_of_birth"
              name="place_of_birth">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col  md="6" lg="4" >
        <b-form-group :label="`${$t('GENDER')} *`">
          <b-select  :options="genderOptions"
            type="select"
            v-model="applicantData.gender"
            name="gender">
          </b-select>
          <validation-description :show="$v.applicantData.gender.$dirty && $v.applicantData.gender.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6"  lg="4" style="height: 4rem">
        <b-form-group :label="`${$t('ECONOMY')} *`" label-size="sm" class="mt-1">
          <country v-model="applicantData.country" id="tooltip-target-16"></country>
          <validation-description :show="$v.applicantData.country.$dirty && $v.applicantData.country.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>

      <b-col  md="6" lg="4">
          <b-form-group :label="`${$t('TOWN')}`">
            <b-form-input
              type="text"
              v-model="applicantData.town">
            </b-form-input>
          </b-form-group>
      </b-col>
      <b-col  md="6" lg="4">
          <b-form-group :label="$t('NATIONALITY')">
          <b-form-input
            type="text"
            v-model.trim="applicantData.nationality"
            name="nationality">
          </b-form-input>
        </b-form-group>

      </b-col>
      <b-col  lg="12">
        <b-form-group :label="$t('CONTACT')">
          <b-form-textarea
              :tabindex="8"
              type="text"
              v-model.trim="applicantData.contact"
              rows="1"
              name="contact">
          </b-form-textarea>
        </b-form-group>
      </b-col>

    </b-row>
    <div class="d-flex">

        <submit-button class="mr-auto"  :loading="loading" :disabled="applicant.status && applicant.status.id !== STATUS_IN_PROCESS" :c_permission="C_APPLICANT_SAVE_BUTTON"></submit-button>
        <delete-button @click="showDeleteDialog=true"
                        :disabled="applicant.status && applicant.status.id !== STATUS_IN_PROCESS"
                        :c_permission="C_APPLICANT_DELETE_BUTTON">
        </delete-button>
        <delete-dialog  :show="showDeleteDialog"
                        @confirm="deleteApp"
                        @cancel="showDeleteDialog=false">
        </delete-dialog>

    </div>
    <hr class="hr">
    <b-row>
        <b-col class="mb-3" md="6" lg="2">
            <p class="mb-1">{{$t('RECORD_WAS_CREATED')}}: {{applicant.insert_user ? applicant.insert_user.first_name : ""}} {{applicant.insert_user ? applicant.insert_user.last_name : ""}}</p>
        </b-col>
        <b-col class="mb-3" md="6" lg="2">
            <p class="mb-1">{{$t('DATE_CREATION')}}: {{formatDate(applicant.created_at)}}</p>
        </b-col>
        <template v-if="applicant.update_user" >
        <b-col class="mb-3" md="6" lg="2">
           <p class="mb-1">{{$t('LAST_MODIFIED')}}: <span v-if="applicant.hasOwnProperty('update_user')">{{applicant.update_user.first_name }} {{applicant.update_user.last_name }}</span></p>
        </b-col>
        <b-col class="mb-3" md="6" lg="2">
           <p class="mb-1">{{$t('LAST_CHANGE')}}: {{formatDate(applicant.updated_at)}}</p>
        </b-col>
        </template>
    </b-row>
  </b-form>
</template>

<script>
  import Country from '@/components/applicant/recognation/fields/Country'
  import SubmitButton from '@/components/app/AppSubmit'
  import {toast} from '@/shared/plugins/toastr'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import DeleteButton from '@/components/app/AppDelete'
  import DeleteDialog from '@/components/app/form/AppConfirmationDialog'
  import DatePicker from '@/components/app/datetime/DatePicker'
  import {deleteApplicant} from "@/services/applicant";
  import routeNames from '@/router/routeNames'
  import {required} from 'vuelidate/lib/validators'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import moment from 'moment'
  import i18n from '@/locale/index'
  import {C_APPLICANT_SAVE_BUTTON} from '@/shared/component_permission'
  import {C_APPLICANT_DELETE_BUTTON} from '@/shared/component_permission'
  import {STATUS_COMPLETE,STATUS_IN_PROCESS} from '@/shared/constants';
  import {cloneDeep} from "lodash";

  export default {
        name: "BasicUpdateForm",
      data(){
          return {
            genderOptions:[
              {value:null, text:'-'},
              {value:'m', text: this.$t('MALE')},
              {value:'z', text: this.$t('FEMALE')}
            ],
            showDeleteDialog:false,
            C_APPLICANT_SAVE_BUTTON,
            C_APPLICANT_DELETE_BUTTON,
            STATUS_IN_PROCESS,
            loading:false,
            STATUS_COMPLETE,
            applicantData: {}
          }
      },
      mixins: [getErrorMessage],
      components:{
        SubmitButton,
        DeleteButton,
        DeleteDialog,
        DatePicker,
        ValidationDescription,
        Country
      },
      validations:{
          applicantData: {
            first_name:{required},
            last_name:{required},
            country:{required},
            gender: {required}
          }
      },
      computed:{
        applicant(){
          return this.$store.getters['applicant/getApplicant']
        },
      },

      methods:{
          formatDate(value){
            if(value){
              const momentDate = new moment(value)

              return momentDate.format('DD.MM.YYYY HH:mm')
            } else {
              return null
            }
          },
          save(){
            const object = {
              first_name: this.applicantData.first_name,
              last_name: this.applicantData.last_name,
              gender: this.applicantData.gender,
              date_of_birth: this.applicantData.date_of_birth,
              place_of_birth: this.applicantData.place_of_birth,
              nationality:this.applicantData.nationality,
              contact:this.applicantData.contact,
              town:this.applicantData.town,
              country:this.applicantData.country.id
            }

            this.$v.$touch()
             if(this.$v.$invalid){
               toast({
                'title': this.$t('VALIDATION_FAILED'),
                'message': null,
                'type': 'error',
                'timeout': 6000
              })
              return
            }
            this.loading = true
            this.$store.dispatch('applicant/actionUpdateApplicant',{ id:Number(this.$route.params.id), object})
              .then(() => {

                  toast({
                    'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                    'message': null,
                    'type': 'success',
                    'timeout': 2000
                  })
                }, error => {
                  toast({
                    'title': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
                    'message': null,
                    'type': 'error',
                    'timeout': 2000
                  })
                }
              ).finally(()=>{
              this.loading = false
            })
          },
        deleteApp(){
          deleteApplicant(this.applicant.id)
            .then(response => {
              if(response.data){
                this.$router.push({name: routeNames.RN_APPLICANTS})
                toast({
                  'title': this.$t('NOTIFICATIONS.DELETE_SUCCESS.MESSAGE'),
                  'message': null,
                  'type': 'success',
                  'timeout': 2000
                })
              } else {
                toast({
                  'title': "Delete  fail",
                  'type': 'error',
                  'timeout': 3000
                })
              }

            },error => {
              toast({
                'title': "Delete  fail",
                'message': this.getMessages(error),
                'type': 'error',
                'timeout': 6000
              })
            })
        },
        updateDateOfBirth(value) {
          this.applicantData.date_of_birth = value;
        },
      },
      watch: {
        applicant: {
          async handler(object) {
            this.applicantData = await cloneDeep(object);
          }, immediate: true
        }
      }
    }
</script>

<style scoped>
.hr {
  width:70%;
  text-align:left;
  margin-left:0
}
</style>
